import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { KineticHero } from "@/components/KineticHero";
import { Marquee } from "@/components/Marquee";
import { ManifestoSection } from "@/components/ManifestoSection";
import { ProductGrid } from "@/components/ProductGrid";
import { CTASection } from "@/components/CTASection";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="app-root" className="relative min-h-screen bg-ink text-foreground">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <KineticHero />
        <Marquee />
        <ManifestoSection />
        <ProductGrid />
        <CTASection />
      </main>
    </div>
  );
}

export default App;
